export default "__VITE_ASSET__CnQWXIks__"